module.exports = __webpack_public_path__ + "static/media/dummy_user.6cf9d86a.jpeg";